import Image from '@/routing/Image'
import { Store } from 'lucide-react'

interface PublisherPillProps {
  icon: string | null
  name: string
  iconOnly?: boolean
}

export function PublisherPill({ icon, name, iconOnly = false }: PublisherPillProps) {
  const iconElement = icon ? (
    <div className="flex h-5 w-5 items-center justify-center rounded-full overflow-hidden bg-white/10">
      <Image
        src={icon}
        alt={name || 'Publisher'}
        width={20}
        height={20}
        className="h-5 w-5 rounded-full object-cover"
      />
    </div>
  ) : (
    <div className="flex h-5 w-5 items-center justify-center rounded-full bg-[#162C27]">
      <Store className="h-3.5 w-3.5 text-[#A4E4CD]" />
    </div>
  )

  if (iconOnly) {
    return (
      <div
        data-testid="publisher-pill"
        className="inline-flex h-[28px] w-[28px] items-center justify-center rounded-full bg-black/45 backdrop-blur-[12px]"
      >
        {iconElement}
      </div>
    )
  }

  return (
    <div
      data-testid="publisher-pill"
      className="flex items-center gap-1.5 bg-black/45 backdrop-blur-[12px] px-2.5 py-1 rounded-full"
    >
      {iconElement}
      <span className="text-xs font-medium text-white/90">{name}</span>
    </div>
  )
}
